// Size Swatch Functionality with AJAX Product Switching
// CC Custom - Cobolt Theme
// Supports both legacy (tag-based) and new (metafield JSON) swatch systems
// Supports multi-option combinations (e.g., Color + Size where each combo is a separate product)
(function() {
  'use strict';

  var COLOR_MAP = {
    'red': 'red', 'blue': 'blue', 'green': 'green', 'yellow': 'yellow',
    'orange': 'orange', 'purple': 'purple', 'pink': 'pink', 'black': 'black',
    'white': 'white', 'grey': 'grey', 'gray': 'gray', 'brown': '#8B4513',
    'beige': 'beige', 'navy': 'navy', 'light blue': '#ADD8E6', 'dark blue': '#00008B',
    'sky blue': '#87CEEB', 'royal blue': '#4169E1', 'navy blue': '#000080',
    'light green': '#90EE90', 'dark green': '#006400', 'forest green': '#228B22',
    'light grey': '#D3D3D3', 'dark grey': '#A9A9A9', 'charcoal': '#36454F',
    'cream': '#FFFDD0', 'ivory': '#FFFFF0', 'gold': '#FFD700', 'silver': '#C0C0C0',
    'bronze': '#CD7F32', 'coral': '#FF7F50', 'teal': '#008080', 'turquoise': '#40E0D0',
    'maroon': '#800000', 'burgundy': '#800020', 'olive': '#808000', 'tan': '#D2B48C',
    'peach': '#FFCBA4', 'lavender': '#E6E6FA', 'magenta': '#FF00FF', 'cyan': '#00FFFF',
    'aqua': '#00FFFF', 'mint': '#98FF98', 'rose': '#FF007F', 'salmon': '#FA8072',
    'khaki': '#C3B091', 'indigo': '#4B0082', 'violet': '#EE82EE', 'plum': '#DDA0DD',
    'crimson': '#DC143C', 'scarlet': '#FF2400', 'mustard': '#FFDB58', 'lime': '#00FF00',
    'champagne': '#F7E7CE', 'rust': '#B7410E', 'copper': '#B87333', 'natural': '#F5F5DC',
    'aqua blue': '#00CED1', 'blue pink': '#FF69B4', 'blush pink': '#FFB6C1',
    'dark purple': '#301934', 'grape purple': '#6F2DA8', 'jade green': '#00A86B',
    'lime green': '#32CD32', 'pastel blue': '#AEC6CF'
  };

  function getColorValue(colorName) {
    var key = colorName.toLowerCase().trim();
    return COLOR_MAP[key] || colorName;
  }

  function isLegacyMode() {
    return document.querySelector('.product-colours-container, .product-sizes-container') !== null &&
           document.querySelector('.cc-swatch-option-group') === null;
  }

  // ============================================
  // COMBINATION LOOKUP FUNCTIONS (for multi-option products)
  // ============================================

  function getCombinations() {
    var wrapper = document.getElementById('size-swatch-wrapper');
    if (!wrapper) return null;
    var data = wrapper.getAttribute('data-combinations');
    if (!data) return null;
    try { return JSON.parse(data); } catch(e) { return null; }
  }

  function showSoftMatchMessage(show) {
    var msg = document.querySelector('.cc-soft-match-message');
    if (msg) msg.style.display = show ? 'block' : 'none';

    // Disable/enable the Add to Cart button
    var addToCartBtn = document.querySelector('.js-btn-add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.disabled = show;
      if (show) {
        addToCartBtn.classList.add('disabled', 'cc-opacity-50', 'cc-cursor-not-allowed');
      } else {
        addToCartBtn.classList.remove('disabled', 'cc-opacity-50', 'cc-cursor-not-allowed');
      }
    }
  }

  function getCurrentSelections() {
    var wrapper = document.getElementById('size-swatch-wrapper');
    var selections = {};
    if (wrapper) {
      var data = wrapper.getAttribute('data-current-selections');
      if (data) {
        try { selections = JSON.parse(data); } catch(e) {}
      }
    }
    document.querySelectorAll('.cc-swatch-option-group').forEach(function(group) {
      var optionName = group.getAttribute('data-swatch-name');
      var currentSwatch = group.querySelector('.btn-colour-swatch.current, .btn-size-swatch.current, .btn-image-swatch.current');
      if (optionName && currentSwatch) {
        selections[optionName] = currentSwatch.getAttribute('data-swatch-label');
      }
    });
    return selections;
  }

  function buildCombinationKey(selections) {
    var wrapper = document.getElementById('size-swatch-wrapper');
    var keys = [];

    // Use JSON option order if available (for correct combination key matching)
    var jsonOrderAttr = wrapper ? wrapper.getAttribute('data-json-option-order') : null;

    if (jsonOrderAttr) {
      // Build key using original JSON order (not DOM order)
      var jsonOrder = jsonOrderAttr.split('||');
      jsonOrder.forEach(function(optionName) {
        if (selections[optionName]) {
          keys.push(selections[optionName]);
        }
      });
    } else {
      // Fallback: use DOM order
      document.querySelectorAll('.cc-swatch-option-group').forEach(function(group) {
        var optionName = group.getAttribute('data-swatch-name');
        if (optionName && selections[optionName]) {
          keys.push(selections[optionName]);
        }
      });
    }

    return keys.join('|');
  }

  function resolveProductHandle(clickedSwatch) {
    var combinations = getCombinations();
    if (!combinations) {
      return clickedSwatch.getAttribute('data-product-handle');
    }
    var selections = getCurrentSelections();
    var optionName = clickedSwatch.getAttribute('data-option-name');
    var newValue = clickedSwatch.getAttribute('data-swatch-label');
    if (optionName) {
      selections[optionName] = newValue;
    }
    var key = buildCombinationKey(selections);
    var handle = combinations[key];
    if (!handle) {
      console.warn('No product found for combination:', key);
    }
    return handle || null;
  }

  // ============================================
  // UPDATE AVAILABLE SWATCHES (disable invalid combinations)
  // ============================================

  function updateAvailableSwatches() {
    var combinations = getCombinations();
    if (!combinations) return; // Only applies to multi-option mode

    var currentSelections = getCurrentSelections();

    // For each option group, check which swatches are valid
    document.querySelectorAll('.cc-swatch-option-group').forEach(function(group) {
      var optionName = group.getAttribute('data-swatch-name');
      var swatches = group.querySelectorAll('.btn-colour-swatch, .btn-size-swatch, .btn-image-swatch');

      // Skip disabling for soft match options - always keep swatches enabled
      if (group.hasAttribute('data-soft-match')) {
        swatches.forEach(function(swatch) {
          swatch.classList.remove('disabled');
          swatch.removeAttribute('disabled');
        });
        return;
      }

      swatches.forEach(function(swatch) {
        var swatchLabel = swatch.getAttribute('data-swatch-label');

        // Build a hypothetical selection with this swatch chosen
        var testSelections = Object.assign({}, currentSelections);
        testSelections[optionName] = swatchLabel;

        // Build the combination key
        var testKey = buildCombinationKey(testSelections);

        // Check if this combination exists
        if (combinations[testKey]) {
          swatch.classList.remove('disabled');
          swatch.removeAttribute('disabled');
        } else {
          swatch.classList.add('disabled');
          swatch.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  // ============================================
  // LEGACY MODE FUNCTIONS
  // ============================================

  function renderSizeSwatches(data, currentProductId) {
    var container = document.querySelector('.product-sizes-container');
    if (!container) return;
    var html = '<div class="product-sizes flex flex-wrap cc-gap-x-[30px] cc-gap-y-[10px]">';
    var productsArray = Object.values(data.products);
    var sortedProducts = productsArray.sort(function(a, b) {
      if (a.size && b.size) {
        var numA = parseInt(a.size), numB = parseInt(b.size);
        return isNaN(numA) || isNaN(numB) ? a.size.localeCompare(b.size) : numA - numB;
      }
      return 0;
    });
    var renderedSizes = new Set();
    sortedProducts.forEach(function(product) {
      var size = product.size;
      if (!size || renderedSizes.has(size)) return;
      renderedSizes.add(size);
      var isCurrent = parseInt(product.id) === currentProductId;
      var handle = product.url.split('/products/')[1]?.split('?')[0] || '';
      html += '<button type="button" class="btn-size-swatch' + (isCurrent ? ' current' : '') + '"';
      html += ' data-product-size="' + size + '" data-product-handle="' + handle + '"';
      html += ' data-product-available="' + product.available + '">' + size + '</button>';
      if (isCurrent) {
        var label = container.querySelector('.cc__current');
        if (label) label.textContent = size;
      }
    });
    var wrapper = document.getElementById('size-swatch-wrapper') || container.parentElement;
    if (renderedSizes.size <= 1) { if (wrapper) wrapper.style.display = 'none'; return; }
    if (wrapper) wrapper.style.display = '';
    html += '</div>';
    var oldSwatches = container.querySelector('.product-sizes');
    if (oldSwatches) oldSwatches.remove();
    var titleEl = container.querySelector('.title');
    if (titleEl) titleEl.insertAdjacentHTML('afterend', html);
  }

  function renderColourSwatches(data, currentProductId) {
    var container = document.querySelector('.product-colours-container');
    if (!container) return;
    var html = '<div class="product-colours flex flex-wrap cc-gap-x-[10px] cc-gap-y-[10px]">';
    var productsArray = Object.values(data.products);
    var sortedProducts = productsArray.sort(function(a, b) {
      return (a.colour && b.colour) ? a.colour.localeCompare(b.colour) : 0;
    });
    var renderedColours = new Set();
    sortedProducts.forEach(function(product) {
      var colour = product.colour;
      if (!colour || renderedColours.has(colour)) return;
      renderedColours.add(colour);
      var isCurrent = parseInt(product.id) === currentProductId;
      var handle = product.url.split('/products/')[1]?.split('?')[0] || '';
      var colourName = colour.replace(/_/g, ' ');
      html += '<div class="cc-swatch-container"><button type="button" class="btn-colour-swatch cursor-pointer' + (isCurrent ? ' current' : '') + '"';
      html += ' data-product-colour="' + colour + '" data-product-handle="' + handle + '"';
      html += ' data-product-available="' + product.available + '"';
      html += ' style="background-color: ' + getColorValue(colourName) + ';" title="' + colourName + '"></button></div>';
      if (isCurrent) {
        var label = container.querySelector('.cc__current');
        if (label) label.textContent = colourName;
      }
    });
    var wrapper = document.getElementById('colour-swatch-wrapper') || container.parentElement;
    if (renderedColours.size <= 1) { if (wrapper) wrapper.style.display = 'none'; return; }
    if (wrapper) wrapper.style.display = '';
    html += '</div>';
    var oldSwatches = container.querySelector('.product-colours');
    if (oldSwatches) oldSwatches.remove();
    var titleEl = container.querySelector('.title');
    if (titleEl) titleEl.insertAdjacentHTML('afterend', html);
  }

  function fetchColourSwatches() {
    return new Promise(function(resolve) {
      var container = document.querySelector('.product-colours-container');
      if (!container) { resolve(); return; }
      var groupTag = container.getAttribute('data-colour-group');
      var productId = parseInt(container.getAttribute('data-current-product-id'));
      if (!groupTag) { resolve(); return; }
      groupTag = groupTag.replace(/\+/g, '');
      fetch('/collections/all/' + groupTag + '?view=swatch')
        .then(function(r) { return r.text(); })
        .then(function(text) {
          try { renderColourSwatches(JSON.parse(text), productId); } catch(e) {}
          resolve();
        }).catch(function() { resolve(); });
    });
  }

  function fetchSizeSwatches() {
    return new Promise(function(resolve) {
      var container = document.querySelector('.product-sizes-container');
      if (!container) { resolve(); return; }
      var groupTag = container.getAttribute('data-size-group');
      var productId = parseInt(container.getAttribute('data-current-product-id'));
      if (!groupTag) { resolve(); return; }
      groupTag = groupTag.replace(/\+/g, '');
      fetch('/collections/all/' + groupTag + '?view=swatch')
        .then(function(r) { return r.text(); })
        .then(function(text) {
          try { renderSizeSwatches(JSON.parse(text), productId); } catch(e) {}
          resolve();
        }).catch(function() { resolve(); });
    });
  }

  // ============================================
  // AJAX PRODUCT FETCHING & PAGE UPDATE
  // ============================================

  // Initialize product tabs click handlers (for both desktop tabs and mobile accordion)
  function initProductTabs() {
    // Desktop tabs - handle click to switch tabs
    document.querySelectorAll('.cc__producttab__listitem').forEach(function(tab) {
      if (tab.hasAttribute('data-tab-initialized')) return;
      tab.setAttribute('data-tab-initialized', 'true');
      tab.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');
        var container = this.closest('.cc__producttab__list');
        if (!container) return;

        container.querySelectorAll('.cc__producttab__listitem').forEach(function(t) {
          t.removeAttribute('open');
        });
        container.querySelectorAll('.cc__producttab__content').forEach(function(c) {
          c.removeAttribute('open');
        });

        this.setAttribute('open', '');
        var content = container.querySelector('#' + tabId);
        if (content) content.setAttribute('open', '');
      });
    });

    // Desktop tabs: open first by default if none are open
    document.querySelectorAll('.cc__producttab__list').forEach(function(list) {
      if (!list.querySelector('.cc__producttab__listitem[open]')) {
        var firstTab = list.querySelector('.cc__producttab__listitem');
        var firstContent = list.querySelector('.cc__producttab__content');
        if (firstTab) firstTab.setAttribute('open', '');
        if (firstContent) firstContent.setAttribute('open', '');
      }
    });

    // Mobile accordion - full behavior matching inline script
    document.querySelectorAll('.cc__productaccordion_list').forEach(function(accordionList) {
      if (accordionList.hasAttribute('data-accordion-init')) return;
      accordionList.setAttribute('data-accordion-init', 'true');

      var items = accordionList.querySelectorAll('.cc__productaccordion_list_item');
      if (items.length === 0) return;

      // Open first item by default
      items[0].setAttribute('open', '');

      // Attach click handlers to entire item (not just h3)
      items.forEach(function(item) {
        item.addEventListener('click', function(event) {
          var current = event.currentTarget;

          // Single-open: close all others in this list
          items.forEach(function(other) {
            if (other !== current) other.removeAttribute('open');
          });

          // Toggle current
          if (current.hasAttribute('open')) {
            current.removeAttribute('open');
          } else {
            current.setAttribute('open', '');

            // Auto-play video if present
            var video = current.querySelector('video');
            if (video && video.paused) {
              video.play().catch(function() {});
            }

            // Scroll into view with header offset
            setTimeout(function() {
              var header = document.querySelector('header') || document.querySelector('.shopify-section-header');
              var headerOffset = header ? header.offsetHeight : 0;
              var pos = current.getBoundingClientRect().top + window.pageYOffset - headerOffset - 10;
              window.scrollTo({ top: pos, behavior: 'smooth' });
            }, 100);
          }
        });
      });
    });
  }

  async function fetchProductData(handle) {
    try {
      var r = await fetch('/products/' + handle + '.json');
      if (!r.ok) throw new Error();
      return (await r.json()).product;
    } catch(e) { return null; }
  }

  async function fetchProductHTML(handle, sectionName) {
    try {
      var r = await fetch('/products/' + handle + '?sections=' + sectionName);
      if (!r.ok) throw new Error();
      return (await r.json())[sectionName];
    } catch(e) { return null; }
  }

  function updateProductPage(product, sectionHTML) {
    var variant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    var titleEl = document.querySelector('.cc__producttitle');
    if (titleEl) titleEl.textContent = product.title;
    var skuEl = document.querySelector('.cc__productcurrentSKU');
    if (skuEl) {
      if (variant && variant.sku) { skuEl.textContent = 'Product code: ' + variant.sku; skuEl.style.display = ''; }
      else { skuEl.style.display = 'none'; }
    }
    var descEl = document.querySelector('.cc-product-description');
    if (descEl && product.body_html) {
      var plainText = product.body_html.replace(/<[^>]*>/g, '').substring(0, 150);
      descEl.innerHTML = plainText + '...<button class="cc-read-more-btn cc-text-[#759C98] cc-underline cc-font-semibold cc-text-[12px]" onclick="scrollToProductDescTab()">Read More</button>';
    }
    if (variant) {
      var price = Math.round(parseFloat(variant.price) * 100);
      var comparePrice = variant.compare_at_price ? Math.round(parseFloat(variant.compare_at_price) * 100) : null;
      var exVatPrice = Math.round(price / 1.2);
      function formatMoney(cents) { return '\u00A3' + (cents / 100).toFixed(2); }
      var incVatPriceEl = document.querySelector('.cc-price-amount.js-inc-vat');
      if (incVatPriceEl) { incVatPriceEl.textContent = formatMoney(price); incVatPriceEl.setAttribute('data-price', price); }
      var exVatPriceEl = document.querySelector('.cc-price-amount.js-ex-vat');
      if (exVatPriceEl) { exVatPriceEl.textContent = formatMoney(exVatPrice); exVatPriceEl.setAttribute('data-price', exVatPrice); }
      var incVatCompareEl = document.querySelector('.cc-price-compare.js-inc-vat');
      var exVatCompareEl = document.querySelector('.cc-price-compare.js-ex-vat');
      var stickyPriceInc = document.querySelector('[data-sticky-price-inc]');
      var stickyPriceEx = document.querySelector('[data-sticky-price-ex]');
      if (stickyPriceInc) stickyPriceInc.textContent = formatMoney(price);
      if (stickyPriceEx) stickyPriceEx.textContent = formatMoney(exVatPrice);
      if (comparePrice && comparePrice > price) {
        if (incVatCompareEl) { incVatCompareEl.textContent = formatMoney(comparePrice); incVatCompareEl.style.display = ''; }
        if (exVatCompareEl) { exVatCompareEl.textContent = formatMoney(Math.round(comparePrice / 1.2)); exVatCompareEl.style.display = ''; }
      } else {
        if (incVatCompareEl) incVatCompareEl.style.display = 'none';
        if (exVatCompareEl) exVatCompareEl.style.display = 'none';
      }
      var variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
      if (variantInput) variantInput.value = variant.id;
      var prodBtnGroup = document.querySelector('.js-prod-btn-group');
      if (prodBtnGroup) prodBtnGroup.setAttribute('data-cv-price', price);
    }
    if (sectionHTML) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = sectionHTML;
      var newAvailEl = tempDiv.querySelector('.availability');
      var currentAvailEl = document.querySelector('.availability');
      if (newAvailEl && currentAvailEl) currentAvailEl.outerHTML = newAvailEl.outerHTML;
      var newBtn = tempDiv.querySelector('.js-btn-add-to-cart');
      var currentBtn = document.querySelector('.js-btn-add-to-cart');
      if (newBtn && currentBtn) { currentBtn.disabled = newBtn.disabled; currentBtn.className = newBtn.className; currentBtn.innerHTML = newBtn.innerHTML; }
      var newGallery = tempDiv.querySelector('.product-images .cc-flex.cc-flex-col');
      var currentGallery = document.querySelector('.product-images .cc-flex.cc-flex-col');
      if (newGallery && currentGallery) {
        currentGallery.innerHTML = newGallery.innerHTML;
        if (typeof Swiper !== 'undefined') {
          document.querySelectorAll('.cc-product-swiper').forEach(function(el) {
            if (el.swiper) el.swiper.destroy(true, true);
            new Swiper(el, { slidesPerView: 1, spaceBetween: 10, pagination: { el: '.cc-swiper-pagination', clickable: true } });
          });
        }
      }

      // Swap the metafield-driven buy-column zones that differ per product.
      // These render conditionally per product (at a glance, reassurance
      // line, quantity presets, review quote), so: when both old and new
      // exist, replace; when the new product lacks the zone, hide the old
      // one (never remove, so a later switch can restore it); when it
      // reappears, the outerHTML swap restores visibility.
      ['.cc-glance', '.cc-picker-reassure', '.cc-qty-presets', '.cc-rquote'].forEach(function(sel) {
        var newEl = tempDiv.querySelector(sel);
        var curEl = document.querySelector(sel);
        if (newEl && curEl) {
          curEl.outerHTML = newEl.outerHTML;
        } else if (curEl && !newEl) {
          curEl.style.display = 'none';
        }
      });

      // Update product tabs — handle ALL tab wrappers (desktop + mobile)

      var currentWrappers = document.querySelectorAll('[id^="cc-product-tabs-"]');
      var newWrappersInTemp = tempDiv.querySelectorAll('[id^="cc-product-tabs-"]');

      if (currentWrappers.length > 0 && newWrappersInTemp.length > 0) {
        // 1. Remove ALL old scoped tab styles from the document
        document.querySelectorAll('style').forEach(function(style) {
          if (style.textContent.includes('cc-product-tabs-') &&
              style.textContent.includes('cc__producttab')) {
            style.remove();
          }
        });

        // 2. Inject ALL new style tags into <head>
        tempDiv.querySelectorAll('style').forEach(function(style) {
          if (style.textContent.includes('cc-product-tabs-') &&
              style.textContent.includes('cc__producttab')) {
            document.head.appendChild(style.cloneNode(true));
          }
        });

        // 3+4. Pair current and new wrappers, then replace.
        //    Match by -desktop/-mobile suffix when the IDs carry one;
        //    otherwise pair by position. The live wrapper IDs carry no
        //    suffix (e.g. cc-product-tabs-<product id>), so the previous
        //    suffix-only map never matched anything and the tab zone was
        //    silently left showing the previous product's content.
        var newArr = Array.from(newWrappersInTemp);
        Array.from(currentWrappers).forEach(function(cw, i) {
          var nw = null;
          if (cw.id.indexOf('-desktop') !== -1) {
            nw = newArr.find(function(n) { return n.id.indexOf('-desktop') !== -1; });
          } else if (cw.id.indexOf('-mobile') !== -1) {
            nw = newArr.find(function(n) { return n.id.indexOf('-mobile') !== -1; });
          }
          if (!nw) nw = newArr[i] || newArr[0];
          if (nw && cw.parentElement) {
            cw.parentElement.replaceChild(nw.cloneNode(true), cw);
          }
        });
      }

      // Re-home the panels. The fetched HTML arrives with the content
      // parented in the hidden tab list (server-render state); the
      // snippet's inline script that moves panels into the accordion
      // shells does not execute for injected HTML, so replicate it here
      // for every replaced wrapper or the accordions render empty.
      var ccTabIds = ['taboverview','tabdescription','tabspecs','tabdelivery','tabfaq','tabknowledge'];
      document.querySelectorAll('[id^="cc-product-tabs-"]').forEach(function(wrap) {
        ccTabIds.forEach(function(id) {
          var panel = wrap.querySelector('#' + id);
          var shell = wrap.querySelector('[data-panel-home="' + id + '"]');
          if (panel && shell && panel.parentElement !== shell) {
            shell.appendChild(panel);
          }
        });
      });

      // Re-initialize tab click handlers after DOM replacement
      initProductTabs();

      // Re-apply list item transformation (from cc-custom.js)
      // Wraps li content with p tag for proper width calculation with checkmark icons
      document.querySelectorAll('.cc__productaccordioncontent li, .cc__producttab__content li')
        .forEach(function(li) {
          if (!li.querySelector('p')) {
            var content = li.innerHTML;
            li.innerHTML = '<p class="cc-w-[calc(100%-25px)]">' + content + '</p>';
          }
        });
    }
    history.pushState({ productHandle: product.handle }, product.title, '/products/' + product.handle);
    document.title = product.title + ' - ' + (window.Shopify?.shop || 'Store');
    // Reinitialize the "Buy More, Pay Less" discount table for the new product
    if (typeof window.reinitShopacadoDiscountTable === 'function') {
      window.reinitShopacadoDiscountTable();
    }
    var yotpoEl = document.querySelector('.yotpo-widget-instance');
    if (yotpoEl) {
      yotpoEl.setAttribute('data-yotpo-product-id', product.id);
      if (typeof yotpo !== 'undefined' && yotpo.refreshWidgets) yotpo.refreshWidgets();
    }
    var sizeContainer = document.querySelector('.product-sizes-container');
    if (sizeContainer) sizeContainer.setAttribute('data-current-product-id', product.id);
    var colourContainer = document.querySelector('.product-colours-container');
    if (colourContainer) colourContainer.setAttribute('data-current-product-id', product.id);
    document.querySelectorAll('.cc-swatch-option-group').forEach(function(group) {
      group.setAttribute('data-current-product-handle', product.handle);
    });
  }

  var PRODUCT_SECTION_NAME = 'cc-product';

  async function switchToProduct(handle, clickedSwatch) {
    if (!handle) return;

    // Check if Bold Options has actual content (not just empty div)
    if (document.querySelector('.bold_options .bold_option_set')) {
      window.location.href = '/products/' + handle;
      return;
    }

    var productInfo = document.querySelector('.product-info');
    if (productInfo) productInfo.classList.add('cc-loading');

    var [product, sectionHTML] = await Promise.all([fetchProductData(handle), fetchProductHTML(handle, PRODUCT_SECTION_NAME)]);

    if (product) {
      var combinations = getCombinations();

      if (combinations && clickedSwatch) {
        var optionName = clickedSwatch.getAttribute('data-option-name');
        var group = clickedSwatch.closest('.cc-swatch-option-group');
        if (group) {
          group.querySelectorAll('.btn-colour-swatch, .btn-size-swatch, .btn-image-swatch')
            .forEach(function(el) { el.classList.remove('current'); });
          clickedSwatch.classList.add('current');
          var labelEl = group.querySelector('.cc__current');
          if (labelEl) labelEl.textContent = clickedSwatch.getAttribute('data-swatch-label');
        }
        var wrapper = document.getElementById('size-swatch-wrapper');
        if (wrapper) {
          var selections = getCurrentSelections();
          wrapper.setAttribute('data-current-selections', JSON.stringify(selections));
        }
        // Update available swatches after product switch
        updateAvailableSwatches();
      } else {
        document.querySelectorAll('.btn-size-swatch.current, .btn-colour-swatch.current, .btn-image-swatch.current')
          .forEach(function(el) { el.classList.remove('current'); });
        if (clickedSwatch) {
          clickedSwatch.classList.add('current');
          var swatchLabel = clickedSwatch.getAttribute('data-swatch-label') || clickedSwatch.getAttribute('data-product-colour')?.replace(/_/g, ' ') || clickedSwatch.getAttribute('data-product-size');
          if (swatchLabel) {
            var group = clickedSwatch.closest('.cc-swatch-option-group') || clickedSwatch.closest('.product-colours-container, .product-sizes-container');
            if (group) {
              var labelEl = group.querySelector('.cc__current');
              if (labelEl) labelEl.textContent = swatchLabel;
            }
          }
        }
      }

      updateProductPage(product, sectionHTML);
      if (isLegacyMode()) await Promise.all([fetchColourSwatches(), fetchSizeSwatches()]);
    }

    if (productInfo) productInfo.classList.remove('cc-loading');
  }

  // ============================================
  // EVENT HANDLERS
  // ============================================

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.btn-size-swatch, .btn-colour-swatch, .btn-image-swatch');
    if (swatch && !swatch.classList.contains('current') && !swatch.classList.contains('disabled')) {
      e.preventDefault();
      e.stopPropagation();
      var handle = resolveProductHandle(swatch);

      if (handle) {
        // Valid combination exists - navigate to the product's own URL.
        // A real page load renders EVERYTHING correctly by construction:
        // gallery Swiper + thumbnails initialised, tabs, At a Glance,
        // schema, presets, VAT defaults. The previous AJAX swap replaced
        // DOM that theme components (Swiper, inline snippet scripts,
        // custom elements) could not re-initialise, which corrupted the
        // gallery and broke thumbnails after every switch.
        showSoftMatchMessage(false);
        swatch.style.opacity = '0.55';
        swatch.style.pointerEvents = 'none';
        window.location.assign('/products/' + handle);
      } else {
        // No combination found - check if this is a soft match option
        var group = swatch.closest('.cc-swatch-option-group');

        if (group && group.hasAttribute('data-soft-match')) {
          // Soft match option - update visual selection without switching product
          group.querySelectorAll('.btn-colour-swatch, .btn-size-swatch, .btn-image-swatch')
            .forEach(function(el) { el.classList.remove('current'); });
          swatch.classList.add('current');

          // Update the label if exists
          var labelEl = group.querySelector('.cc__current');
          if (labelEl) labelEl.textContent = swatch.getAttribute('data-swatch-label');

          // Update current selections data attribute
          var wrapper = document.getElementById('size-swatch-wrapper');
          if (wrapper) {
            var selections = getCurrentSelections();
            var optionName = group.getAttribute('data-swatch-name');
            selections[optionName] = swatch.getAttribute('data-swatch-label');
            wrapper.setAttribute('data-current-selections', JSON.stringify(selections));
          }

          // Show the "not available" message
          showSoftMatchMessage(true);

          // Re-evaluate available swatches based on new selection
          updateAvailableSwatches();
        }
      }
    }
  });

  // popstate handler removed: with real navigations the browser's own
  // back/forward restores complete, correctly initialised pages.

  // ============================================
  // INITIALIZATION
  // ============================================

  function initSwatches() {
    if (isLegacyMode()) return Promise.all([fetchColourSwatches(), fetchSizeSwatches()]);
    var wrapper = document.getElementById('size-swatch-wrapper');
    var swatchGroups = document.querySelectorAll('.cc-swatch-option-group');
    if (wrapper && swatchGroups.length > 0) {
      var hasMultipleOptions = false;
      swatchGroups.forEach(function(group) {
        var swatches = group.querySelectorAll('.btn-colour-swatch, .btn-size-swatch, .btn-image-swatch');
        if (swatches.length <= 1) group.style.display = 'none';
        else { group.style.display = ''; hasMultipleOptions = true; }
      });
      wrapper.style.display = hasMultipleOptions ? '' : 'none';
      // Update available swatches on initialization
      updateAvailableSwatches();
    }
    // Initialize product tabs click handlers
    initProductTabs();
    return Promise.resolve();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSwatches);
  else initSwatches();
})();